import * as React from 'react';
import { FooterLinks } from './FooterLinks';
import { BackToTop } from './BackToTop';
import { FooterCredits } from './FooterCredits';
import './style.css';

export interface FooterProps {
  /* empty */
}

export interface FooterState {
  /* empty */
}

export class Footer extends React.Component<FooterProps, FooterState> {
  render() {
    return (
      <footer className="footer">
        <BackToTop />
        <FooterLinks />
        <FooterCredits />
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/index.tsx